module.exports = __webpack_public_path__ + "img/275.a434faf9.png";